import {
  AuxEngineReport,
  EngineReportsVm,
  MainEngineReport,
} from '@navstation-portal/reporting/data-model/engine-reports';

export function buildEngineReportsVm(meReports: MainEngineReport[], aeReports: AuxEngineReport[]): EngineReportsVm {
  const sorted = [...meReports].sort((a, b) => a.reportNumber - b.reportNumber);
  const latestReport = sorted.length > 0 ? sorted[sorted.length - 1] : undefined;
  const incompleteReportId = latestReport && latestReport.status !== 'completed' ? latestReport.id : null;

  return {
    meReports,
    aeReports,
    incompleteReportId,
  };
}
